module.exports = __webpack_public_path__ + "statics/img/modelCode-oem.0d75bb78.svg";